{
  "//vg-binding": "CONTEXT:decisions=P6.1.D-28,P6.1.D-20 | INTERFACE-STANDARDS:error-shape",
  "page": {
    "title": "Membres",
    "subtitle": "Les personnes de votre entreprise — rôle, équipe et accès au même endroit"
  },
  "actions": {
    "invite": "Inviter un membre",
    "promoteAdmin": "Promouvoir admin",
    "promoteAdminSuccess": "Membre promu administrateur",
    "promoteAdminError": "Impossible de promouvoir le membre"
  },
  "filters": {
    "searchPlaceholder": "Rechercher un nom ou un e-mail...",
    "role": "Rôle : {{value}}",
    "team": "Équipe : {{value}}",
    "status": "Statut : {{value}}",
    "all": "Tous"
  },
  "col": {
    "member": "Membre",
    "role": "Rôle",
    "team": "Équipe",
    "created": "Créé le",
    "updated": "Mis à jour le",
    "status": "Statut",
    "action": "Action"
  },
  "role": {
    "Admin": "Administrateur",
    "Manager": "Responsable",
    "Staff": "Employé",
    "Viewer": "Observateur"
  },
  "status": {
    "Active": "Actif",
    "Deactive": "Désactivé",
    "Invited": "Invité"
  },
  "confirm": {
    "deactivate": {
      "title": "Désactiver ce membre ?",
      "body": "{{name}} perdra l'accès immédiatement. Vous pouvez le réactiver à tout moment.",
      "confirm": "Désactiver",
      "cancel": "Annuler"
    }
  },
  "toast": {
    "inviteSent": "Invitation envoyée",
    "memberUpdated": "Membre mis à jour",
    "toggleActivated": "Membre activé",
    "toggleDeactivated": "Membre désactivé",
    "toggleFailed": "Impossible de mettre à jour le statut du membre"
  },
  "empty": {
    "noResults": "Aucun membre ne correspond à vos filtres",
    "noTeam": {
      "title": "Vous n'êtes pas encore affecté à une équipe",
      "body": "Contactez le propriétaire de la boutique pour être ajouté à une équipe avant de pouvoir voir les commandes, les produits et les données du tableau de bord."
    }
  },
  "error": {
    "loadFailed": "Impossible de charger les membres.",
    "retry": "Réessayer",
    "forbidden": {
      "title": "Accès refusé",
      "body": "Vous n'avez pas la permission de gérer les membres. Contactez le propriétaire de la boutique."
    }
  },
  "breadcrumb": {
    "settings": "Paramètres",
    "members": "Membres"
  },
  "invite": {
    "title": "Inviter un membre",
    "subtitle": "Ils recevront un e-mail pour rejoindre votre entreprise",
    "email": "Adresse e-mail",
    "emailPlaceholder": "membre@entreprise.com",
    "fullName": "Nom complet",
    "namePlaceholder": "Nguyen Van A",
    "role": "Rôle",
    "team": "Équipe",
    "teamPlaceholder": "Sélectionner une équipe",
    "noTeams": "Aucune équipe pour le moment",
    "monthlyBudget": "Budget mensuel (facultatif)",
    "perOrderLimit": "Limite par commande (facultatif)",
    "send": "Envoyer l'invitation",
    "sending": "Envoi en cours...",
    "permissionHint": {
      "admin": "L'administrateur voit toutes les équipes, boutiques et membres de l'entreprise.",
      "manager": "Le responsable ne voit que les commandes, produits et tableau de bord des boutiques de {{team}}, et peut gérer cette équipe.",
      "staff": "L'employé ne voit que les commandes, produits et tableau de bord des boutiques de {{team}}.",
      "viewer": "L'observateur a un accès en lecture seule aux boutiques de {{team}}."
    },
    "error": {
      "duplicate": "Cet e-mail est déjà membre de votre entreprise.",
      "promoteOwnerOnly": "Seul le propriétaire de la boutique peut accorder le rôle Administrateur.",
      "generic": "Impossible d'envoyer l'invitation. Veuillez réessayer."
    }
  }
}
